import React from 'react';
import ShopByCollectionItem from './ShopByCollectionItem';
import '@stone/scss/components/shop-by-collection/_shop-by-collection.scss';
const ShopByCollection = ({ title, collections }) => {
    if (!(collections === null || collections === void 0 ? void 0 : collections.length))
        return React.createElement(React.Fragment, null);
    // ANCHOR - RENDER --------------------------------------------------------------------
    return (React.createElement("div", { className: "shop-by-collection" },
        React.createElement("div", { className: "shop-by-collection__title" },
            React.createElement("h2", { className: "font__title" }, title)),
        React.createElement("div", { className: "shop-by-collection__wrapper" }, collections.map((c) => (React.createElement(ShopByCollectionItem, { key: c.category, collection: c }))))));
};
export default ShopByCollection;
